import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { filterRouters, generateMenus } from '@/utils/route.js';
import SidebarItem from './SidebarItem.vue';
import { useStore } from 'vuex';
export default {
  __name: 'SidebarMenu',
  setup(__props) {
    _useCssVars(_ctx => ({
      "v5852b54a": activeBgColor.value
    }));
    const store = useStore();
    const router = useRouter();
    const routes = computed(() => {
      const filterRoutes = filterRouters(router.getRoutes());
      return generateMenus(filterRoutes);
    });
    // 激活路由
    const route = useRoute();
    const activeMenu = computed(() => {
      const {
        path
      } = route;
      return path;
    });

    // 获取激活背景色
    const activeBgColor = computed(() => store.getters.cssVar.subMenuHover);
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        class: "custom-menu",
        "unique-opened": true,
        "background-color": _ctx.$store.getters.cssVar.menuBg,
        "text-color": _ctx.$store.getters.cssVar.menuText,
        "active-text-color": _ctx.$store.getters.cssVar.menuActiveText,
        router: "",
        "default-active": activeMenu.value,
        collapse: !_ctx.$store.getters.sidebarOpened
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, item => {
          return _openBlock(), _createBlock(SidebarItem, {
            key: item.path,
            route: item
          }, null, 8, ["route"]);
        }), 128))]),
        _: 1
      }, 8, ["background-color", "text-color", "active-text-color", "default-active", "collapse"]);
    };
  }
};